// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"375b8e0f","749":"a5c80c62","903":"18c8eb7f","959":"e59ae70b"}[chunkId] + ".chunk.js";
};